export default __webpack_public_path__ + "static/media/logoFESR1420.0664fdb5.png";